export default {
    data(){
        return{
            closeCustomModal: false,
        };
    },
    methods: {
        forceClose_closeDropdownBox(){
            this.$popper.destroyInstance();
        },
        forceClose_closeModal(){
            this.forceKey_forceKeyChange();
        },
    },
}